var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#85cc03",
    fill: "none",
    d: "M19.1914 4.8C17.4623 3.07 15.0735 2 12.4448 2C9.81609 2 7.41729 3.07 5.69815 4.8C3.96902 6.53 2.89955 8.92 2.89955 11.56C2.89955 13.65 3.57921 15.59 4.71864 17.16L2 22L8.69665 20.32C9.0065 20.45 9.32634 20.58 9.64618 20.68C10.5357 20.96 11.4653 21.1 12.4448 21.1C15.0835 21.1 17.4723 20.03 19.2014 18.3C20.9305 16.57 22 14.19 22 11.56C21.99 8.92 20.9205 6.53 19.1914 4.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#85cc03",
    fill: "none",
    d: "M9.81273 14.19C12.325 16.7 15.3877 17.72 16.6388 16.46L18 15.1L15.2676 12.37L13.9064 13.73L10.2731 10.09L11.6343 8.73L8.90192 6L7.54071 7.36C6.27959 8.62 7.3005 11.68 9.81273 14.19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.aef11f9db8f5268cb81e7c902a5c90d8.svg";
export { ForwardRef as ReactComponent };